var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_130",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3154",
    "data-name": "Group 3154",
    transform: "translate(-312 -158)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 312, 158)",
    filter: "url(#Ellipse_130)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130-2",
    "data-name": "Ellipse 130",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(15 15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M6,20.318A1.743,1.743,0,1,1,7.742,22,1.713,1.713,0,0,1,6,20.318Zm1.742-8.953A1.683,1.683,0,1,0,6,9.682,1.713,1.713,0,0,0,7.742,11.365Zm0,5.318A1.683,1.683,0,1,0,6,15,1.713,1.713,0,0,0,7.742,16.682ZM12.666,10.8h8.708a1.122,1.122,0,1,0,0-2.243H12.666a1.122,1.122,0,1,0,0,2.243Zm0,5.318h8.708a1.122,1.122,0,1,0,0-2.243H12.666a1.122,1.122,0,1,0,0,2.243Zm0,5.318h8.708a1.122,1.122,0,1,0,0-2.243H12.666a1.122,1.122,0,1,0,0,2.243Z",
    transform: "translate(328 173)",
    fill: "#989899"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.993455c9841cee5879884f2f74b12ae0.svg";
export { ForwardRef as ReactComponent };